import { useGetNotetakerEntitlementQuery } from './entitlement_api'

export const useNotetakerEntitled = ({ skip = false } = {}) => {
  const { data, isLoading, isError } = useGetNotetakerEntitlementQuery(undefined, { skip })

  return {
    isEntitled: data?.entitled === true,
    isLoading,
    isError,
  }
}
